(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lena-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lena-review-carousel')) {
 customElements.define('lena-review-carousel', class extends HTMLElement {
  connectedCallback() {
   if(this.initialized) return;
   this.initialized = true;
   const track = this.querySelector('.lena-reviews__track');
   const buttons = this.querySelectorAll('button[data-direction]');
   const update = () => { buttons[0].disabled = track.scrollLeft <= 2; buttons[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; };
   buttons.forEach(button => button.addEventListener('click', () => {
    const card = track.querySelector('article');
    const gap = parseFloat(getComputedStyle(track).gap) || 0;
    track.scrollBy({left: (card.getBoundingClientRect().width + gap) * Number(button.dataset.direction), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
   }));
   track.addEventListener('scroll', update, {passive:true});
   this.observer = new ResizeObserver(update); this.observer.observe(track); update();
  }
  disconnectedCallback(){if(this.observer) this.observer.disconnect(); this.initialized = false;}
 });
}

  } catch(e) { console.error(e); }
})();
})();
